import style from "./style/registration.module.scss";
import React from "react";
import {useTranslation} from "react-i18next";
import {Post} from "../../layout/content/post/Post";
import {CounselorField} from "./registration/CounselorField";
import {CounselorGroupField} from "./registration/CounselorGroupField";
import {useCounselorCreator} from "./registration/hooks/useCounselorCreator";
import {useCounselorStore} from "./registration/hooks/counselorStore";

export function CounselorGroupRegistration() {
    /**
     * 상담소속 & 상담소속 관리자 등록 페이지
     */
    const {createCounselorAffiliation} = useCounselorCreator();
    const {counselorDTO, groupDTO, validateAll} = useCounselorStore();


    const {t} = useTranslation("counselorGroup");

    const onClickCreateButton = () => {
        const isValid = validateAll();
        if (!isValid) return false;
        if (!groupDTO || !counselorDTO) return false;

        const isConfirm = window.confirm('소속을 등록하시겠습니까?');
        counselorDTO.consultantDistributionAmount = groupDTO.consultantDistributionAmount
        counselorDTO.affiliationDistributionAmount = groupDTO.affiliationDistributionAmount

        if (isConfirm) {
            createCounselorAffiliation({
                consultantManagerPostDTO: counselorDTO,
                counselingAffiliationPostDTO: groupDTO,
            }).then(() => {
                alert('소속이 등록되었습니다.')
                window.location.href = '/counselor/manager'
            });
        }
    }

    return (
        <>
            <div className={style.postWrapper}>
                <Post buttonTitle={t("counselorGroupRegistration")}
                      title={t("registration.group.title")}
                      buttonOnClickAction={onClickCreateButton} formClassName={style.postForm}>
                    <>
                        {/*  상담 소속정보  */}
                        <CounselorGroupField/>

                        {/*  상담관리자 정보  */}
                        <CounselorField title={t('registration.counselor.title')}/>
                    </>
                </Post>
            </div>
        </>
    );
}